// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PMgmn1HOV2Q_SXF5Pif5{align-items:center;height:32px;display:flex}.YH1VzxoUcci1o8ZJLEQc,.uPb9zf5VpAsw1wYe9o58{color:var(--content-primary-primary);margin-left:8px;font-size:13px;font-weight:400;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"countLabelWrapper": `PMgmn1HOV2Q_SXF5Pif5`,
	"label": `YH1VzxoUcci1o8ZJLEQc`,
	"countLabel": `uPb9zf5VpAsw1wYe9o58`
};
export default ___CSS_LOADER_EXPORT___;
